export default "__VITE_ASSET__KbsLbg3i__"